import { UserProfile } from '../Components/UserProfile'
import { useTranslation } from 'react-i18next'

export default function ProfilePage() {
    const { t } = useTranslation()
    return <UserProfile title={t('My profile', { ns: 'Setting.Profile' })} />
}
